(ns app.front.view.admin.domain-groups.municipality-list
  (:require [app.front.ui :as ui]
            [app.front.ui.i18n :as ui-i18n]
            [app.front.ui.table :as ui-table]
            [app.front.util :as futil]
            [app.front.view.admin.common :as admin-common]
            [app.front.view.admin.domain-groups.common :as domain-groups-common]
            [app.front.view.admin.domain-groups.subs :as domain-groups-subs]
            [app.front.view.admin.subs :as admin-subs]
            [app.front.view.workspace.map :as workspace-map]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [reagent.core :as r]))

(def input-block :div.bx--row.mt-2>div.bx--col-xs-12)

(defn edit-municipality-button [{:keys [tr municipality municipalities *new-municipality *before-munis]}]
  (cc/button {:icon     i/pen
              :kind     :ghost
              :on-click (fn [_]
                          (reset! *before-munis municipalities)
                          (>evt [::admin-subs/dialog-edit
                                 :new-municipality
                                 :municipalities
                                 (-> (->> municipalities
                                          (remove (comp (partial = (:number municipality))
                                                        :number)))
                                     (conj {}))])
                          (reset! *new-municipality municipality))}
             (tr [:edit])))

(defn new-municipality-form [{:keys [tr *new-municipality *before-munis municipalities available-municipalities
                                     default-number default-name editor-lang default-lang get-str disabled?]}]
  (let [default-location (<sub [::domain-groups-subs/default-location])]
    (if @*new-municipality
      (let [{:keys [location name official-name number]} @*new-municipality
            unique-number?                               (domain-groups-common/municipality-numbers-unique? (conj municipalities @*new-municipality))]
        [:div.border-solid.border.border-ui-violet.p-4.rounded
         [:div.w-full.h-64
          [workspace-map/workspace-map (merge-with merge
                                                   {:center (or location
                                                                (<sub [::domain-groups-subs/location-of number])
                                                                default-location)}
                                                   {:events [{:eventType     "singleclick"
                                                              :eventFunction (fn [e]
                                                                               (swap! *new-municipality
                                                                                      assoc
                                                                                      :location
                                                                                      (js->clj (.-coordinate ^js e))))}]})]]

         [:div.mt-2
          [ui-i18n/edit-language-selector {:allowed-locales-sub ::ui-i18n/languages}]]

         [input-block
          [ui-i18n/localized-string-edit
           {:id                  "municipality-name"
            :label-text          (tr [:admin/municipality-name])
            :placeholder         (tr [:placeholder/municipality])
            :on-change           (fn [v]
                                   (swap! *new-municipality assoc :name v)
                                   ;; geocode if we are changing the english name
                                   (when (= default-lang editor-lang)
                                     (>evt [::domain-groups-subs/geocode-municipality
                                            (default-lang v)
                                            (fn [location number]
                                              (swap! *new-municipality
                                                     assoc
                                                     :location location
                                                     :number number))])))
            :allowed-locales-sub ::ui-i18n/languages
            :strings             name}]]
         [input-block
          [ui-i18n/localized-string-edit
           {:id                  "official-municipality-name"
            :label-text          (tr [:admin/official-name])
            :placeholder         (tr [:admin/placeholder-official-name])
            :on-change           (partial swap! *new-municipality assoc :official-name)
            :allowed-locales-sub ::ui-i18n/languages
            :strings             official-name}]]
         [input-block
          [ui/text-input {:id          "municipality-number"
                          :label-text  (tr [:admin/municipality-id])
                          :placeholder (tr [:placeholder/municipality-code])
                          :value       number
                          :invalid     (not unique-number?)
                          :on-change   #(->> %
                                             futil/tval
                                             str/trim
                                             (swap! *new-municipality assoc :number))}]]

         (cc/button {:class-name "mt-4 mr-2"
                     :on-click   (fn [_]
                                   (>evt [::admin-subs/dialog-edit
                                          :new-municipality
                                          :municipalities
                                          @*before-munis])
                                   (reset! *new-municipality nil))}
                    (tr [:admin/discard-municipality]))
         (cc/button {:class-name "mt-4"
                     :on-click   (fn [_]
                                   (>evt [::admin-subs/dialog-edit
                                          :new-municipality
                                          :municipalities
                                          (-> municipalities
                                              rest ;; drop temporary placeholder
                                              (conj (dissoc @*new-municipality :new-municipality?)))])
                                   (reset! *new-municipality nil))
                     ;; for new municipalities, coordinates are required
                     :disabled   (or (not (domain-groups-common/valid-municipality? (<sub [::domain-groups-subs/coordinates])
                                                                                    @*new-municipality))
                                     (not unique-number?))}
                    (tr (if (:new-municipality? @*new-municipality)
                          [:admin/add-municipality-to-group]
                          [:save])))
         (when-not (:new-municipality? @*new-municipality)
           (cc/button {:class-name "mt-4 float-right"
                       :kind       :danger
                       :on-click   (fn [_]
                                     (>evt [::domain-groups-subs/remove-municipality
                                            @*new-municipality])
                                     (reset! *new-municipality nil))}
                      (tr [:admin/remove-municipality])))])
      (when-not disabled?
        (if (seq available-municipalities)
          [admin-common/member-editor {:tr                tr
                                       :no-pills?         true
                                       :groups            available-municipalities
                                       :current-group-ids (->> municipalities (map :db/id) set)
                                       :add-title         :admin/start-add-municipality
                                       :save-fn           #(>evt [::admin-subs/dialog-edit
                                                                  :new-municipality
                                                                  :municipalities
                                                                  (-> available-municipalities
                                                                      (p/find-first {:db/id %})
                                                                      (cons municipalities))])
                                       :val->str          (comp get-str :name)}]
          (cc/button {:on-click (fn [_]
                                  (>evt [::admin-subs/dialog-edit
                                         :new-municipality
                                         :municipalities
                                         ;; add placeholder to prevent "save" until done adding
                                         (conj municipalities {})])
                                  (reset! *before-munis municipalities)
                                  (reset! *new-municipality {:number            default-number
                                                             :name              {default-lang default-name}
                                                             :location          default-location
                                                             :new-municipality? true}))}
                     (tr [:admin/start-add-municipality])))))))


(defn municipality-list [{:keys [tr disabled? default-number default-name default-lang available-municipalities]}]
  (r/with-let [*new-municipality (r/atom nil)
               *before-munis     (r/atom nil)]
    (let [municipalities (<sub [::domain-groups-subs/municipalities])
          editor-lang    (<sub [::ui-i18n/editor-language ::ui-i18n/languages])
          get-str        #(i18n-model/get-text-from-entities-or-map % editor-lang)]
      [:div.mt-4
       (when (seq municipalities)
         [:h5.mb-2 (tr [:admin/group-municipalities])])

       (when (and (not @*new-municipality)
                  (seq municipalities))
         ;; show language selector before table unless editing
         [:div.mt-2
          [ui-i18n/edit-language-selector {:allowed-locales-sub ::ui-i18n/languages}]])

       [ui-table/modern-responsive-table
        {:items   (or municipalities (<sub [::domain-groups-subs/municipalities-sorted]))
         :tr      tr
         :id-func #(:number % "temp")
         :cols    [[:admin/municipality-name-short
                    (comp get-str :name)
                    {:width "25%"}]
                   [:admin/official-name-short
                    (comp get-str :official-name)]
                   [:admin/municipality-id
                    :number
                    {:width "25%"}]
                   (when-not disabled?
                     [""
                      (fn [municipality]
                        (when-not @*new-municipality
                          [edit-municipality-button (util/mmap tr
                                                               municipality
                                                               municipalities
                                                               *new-municipality
                                                               *before-munis)]))])]}]
       [new-municipality-form (util/mmap tr
                                         *new-municipality
                                         *before-munis
                                         municipalities
                                         available-municipalities
                                         default-number
                                         default-name
                                         editor-lang
                                         default-lang
                                         get-str
                                         disabled?)]])))
